// extracted by mini-css-extract-plugin
export default {"wrapper":"LD-z","viewport":"MD-z","container":"ND-z","slide":"OD-z"};